import React from 'react';
import App from 'next/app';
import { isDev, isLocal } from '@utils/env';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import '@styles/globals.scss';
import '@styles/main.scss';
import 'swiper/swiper.scss';
import { isBrowser } from '@utils/env';
import remInit from '@utils/rem';
import erudaInit from '@utils/eruda';
import logger from '@server-utils/client-logger';
import config from '@config/config.js';

// 新版ui
import '@styles/new-main.scss';

isBrowser && remInit();
isBrowser && erudaInit();

!isLocal &&
    Sentry.init({
        dsn: isDev
            ? 'https://430cc76960784d5f8cb5c1c785880b05@sentry.dev.cc.163.com/9'
            : 'https://fb7371289fed49baa204b81091644f2b@sentry.cc.163.com/6',
        integrations: [
            new Integrations.BrowserTracing({
                traceXHR: false,
                traceFetch: false
            })
        ],

        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 1.0
    });

class MyApp extends App {
    componentDidCatch(err, errorInfo) {
        // 打印错误日志，服务端可以监控到
        const errorString = '组件渲染异常 from MyApp' + err.stack;
        logger.error({
            messgae: `${errorString}`,
            paddingMessage: 'error catch by ErrorBoundary'
        });
        Sentry.captureException(err);
        // This is needed to render errors correctly in development / production
        super.componentDidCatch(err, errorInfo);
    }

    render() {
        const { Component, pageProps } = this.props;
        return <Component {...pageProps} />;
    }
}

export default MyApp;
